import * as angular from 'angular';

import { allSettledConfig } from './all-settled.config';

export const allSettledModule = angular.module('go.allSettled', [])
	.config(allSettledConfig)
	.name;
